const defaultObj = {
  showRoofInstallDate: false,
  showCurrentPropertyOwner: false,
  showRepAssistance: false,
  roofInstallDate: {
    year: '',
    month: '',
    day: ''
  },
  warrantyRegistrationNumber: '',
  havePaperWorkForPropertyOwner: '',
  correctPropertyOwner: '',
}

export const incrementStep = () => (dispatch, getState) => {
  const { step } = getState()

  dispatch({
    type: 'SET_STEP',
    step: step + 1
  })
};

export const decrementStep = () => (dispatch, getState) => {
  const { step } = getState()

  dispatch({
    type: 'SET_STEP',
    step: step - 1
  })
};

export const setStep = (newStep) => (dispatch, getState) => {
  const { step } = getState()
  if (step != newStep) {
    dispatch({
      type: 'SET_STEP',
      step: newStep
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

export const setFormData = (hash) => (dispatch) => {
  dispatch({
    type: 'SET_FORM_DATA',
    hash
  })
}

export const setMetadata = (hash) => (dispatch) => {
  dispatch({
    type: 'SET_META_DATA',
    hash
  })
}

export const backToPropertyAddress = () => (dispatch) => {
  dispatch({
    type: 'SET_FORM_DATA',
    hash: defaultObj
  })
}

export const backToForThisProperty = () => (dispatch) => {
  dispatch({
    type: 'BACK_TO_STEP1',
    hash: {
      ...defaultObj,
      propertyClaimedBy: '',
      propertyAddress: {
        street: '',
        streetLine2: '',
        city: '',
        state: '',
        zip: ''
      }
    },
    step: 1
  })
}

export const backToStep3 = () => (dispatch) => {
  dispatch({
    type: 'BACK_TO_STEP3',
    hash: {
      contactInfo: {
        email: '',
        phone: '',
        preferredContactMethods: []
      }
    },
    step: 3
  })
}

export const showModal = () => (dispatch) => {
  dispatch({
    type: "SHOW_MODAL",
    showModal: true,
  });
}

export const hideModal = () => (dispatch) => {
  dispatch({
    type: "SHOW_MODAL",
    showModal: false,
  });
}

export const lookupEmail = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const email = formData.contractorEmail;

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/warranty_claims/contractor_portal_lookup?email=${email}`),
  {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  })
  .then(response => response.json())
  .then(jsonData => {
    const { status } = jsonData
    metadata.lookupResponse = jsonData;
    metadata.emailCheckResponse = status;
  })
  .catch(err => {
    console.log(err);
  }).finally(() => {
    dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    dispatch(setMetadata({emailCheckResponse: metadata.emailCheckResponse}))
    if (step === 1 && metadata.emailCheckResponse) {
      dispatch(setFormData({memberId: metadata.lookupResponse.user.member_id}))
      incrementStep()(dispatch, getState);
    } else if (step === 1 && metadata.emailCheckResponse === false) {
      dispatch(setFormData({showNewContractorForm: true}))
    }
  })
}

export const propertyLookup = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const propertyAddress = {
    property_info: {
      address_line_1: formData.propertyAddress.street,
      address_line_2: formData.propertyAddress.streetLine2,
      city: formData.propertyAddress.city,
      state: formData.propertyAddress.state,
      zip: formData.propertyAddress.zip,
      country: formData.countrySelected
    }
  }

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/contractor/warranties/lookup`),
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(propertyAddress)
    })
    .then(response => response.json())
    .then(jsonData => {
      const { result } = jsonData
      if (result === 'found') {
        metadata.propertyLookupResponse = result;
        metadata.propertyWRN = jsonData.warranty_registration_number;
      } else {
        metadata.propertyLookupResponse = 'not_found';
        _satellite.track("form-error", { errorMsg: 'property address not found' });
      }
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => {
      dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
      if (metadata?.propertyLookupResponse === 'found') {
        dispatch(setMetadata({
            propertyLookupResponse: metadata.propertyLookupResponse,
            propertyWRN: metadata?.propertyWRN
        }))
        getWarrantyDetails()(dispatch, getState);
      } else {
        dispatch(setFormData({
          showRoofInstallDate: false,
          showNoAvailableWarray: true,
        }))
      }
  })
}

export const getWarrantyDetails = (viaRegistrationForm=false) => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const metaWRN = metadata?.propertyWRN;
  const WRN = formData?.warrantyRegistrationNumber || metaWRN;

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch(
      (`${MDMS_URL}/api/v1/contractor/warranties/details?warranty_registration_number=${WRN}`),
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }
    )
    .then(response => response.json())
    .then(jsonData => {
      metadata.warrantyDetails = jsonData;
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => {
      dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
      if(metadata.warrantyDetails?.message === "Invalid Claim Number"){
        dispatch(setFormData({
          showRoofInstallDate: false,
          showNoAvailableWarray: true
        }))
      } else {

        // roofInstall date validation is used
        if(metaWRN && formData.roofInstallDate.day && formData.roofInstallDate.month && formData.roofInstallDate.year){
          const supplyDate = `${formData.roofInstallDate.month.padStart(2, '0')}/${formData.roofInstallDate.day.padStart(2, '0')}/${
            formData.roofInstallDate.year
          }`;
          const installDate = metadata?.warrantyDetails?.product_information?.date_of_installation;

          installDate !== supplyDate &&
          dispatch(setFormData({showRoofInstallDate: false, showNoAvailableWarray: true}));
        }

        if(viaRegistrationForm) {
          // set Address
          const address = {
            street: metadata?.warrantyDetails?.property_information?.address_line_1,
            city: metadata?.warrantyDetails?.property_information?.city,
            state: metadata?.warrantyDetails?.property_information?.state,
            zip: metadata?.warrantyDetails?.property_information?.zip_code
          }
          dispatch(setFormData({
            propertyAddress: {
              ...formData.propertyAddress,
              ...address
            }}))
        }

        // both checks out fine
        dispatch(setMetadata({warrantyDetails: metadata.warrantyDetails}))
        dispatch(setFormData({
          showRoofInstallDate: false,
          showCurrentPropertyOwner: true,
          showNoAvailableWarray: false,
        }))
      }
  })
}

export const setAppData = (hash) => (dispatch) => {
  dispatch({
    type: 'SET_APP_DATA',
    hash: hash
  });
}

export const submitClaim = () => (dispatch, getState) => {
  dispatch({
    type: "DISABLE_SUBMIT_BTN",
    disableSubmitBtn: true,
  });
  const { formData, step, metadata } = getState();
  const {country, propertyClaimedBy, contractorEmail, warrantyRegistrationNumber, contactInfo,
    roofExperiencing, roofExperiencingComments, propertyOwnerInvite, contractorInvite, installingContractorData,
    installingContractor, propertyOwnerEmail, propertyAddress, newContractorInfo, memberId} = formData
  const data = {
    country,
    propertyClaimedBy,
    contractorEmail,
    warrantyRegistrationNumber: metadata?.warrantyDetails?.warranty_registration_number || warrantyRegistrationNumber,
    contactInfo: {
      ...contactInfo,
      firstName: metadata?.warrantyDetails?.property_information?.first_name,
      lastName: metadata?.warrantyDetails?.property_information?.last_name
    },
    roofExperiencing,
    roofExperiencingComments,
    propertyOwnerInvite,
    contractorInvite,
    propertyOwnerEmail,
    propertyAddress,
    newContractorInfo,
    installDate: metadata?.warrantyDetails?.product_information?.date_of_installation,
    product: metadata?.warrantyDetails?.product_information?.product,
    color: metadata?.warrantyDetails?.product_information?.color,
    installingContractor,
    installingContractorData,
    squareInstalled: metadata?.warrantyDetails?.product_information?.square_installed,
    memberId
  }

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/warranty_claims`),
  {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(jsonData => {
    metadata.pqsResponse = jsonData
  })
  .catch(err => {
    console.log(err);
    _satellite.track("form-error", { errorMsg: err });
  }).finally(() => {
    dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    dispatch(setMetadata({pqsResponse: metadata.pqsResponse}))
    dispatch({
      type: "DISABLE_SUBMIT_BTN",
      disableSubmitBtn: false,
    });
    if (metadata.pqsResponse && !metadata.pqsResponse?.message) {
      incrementStep()(dispatch, getState);
    } else if (metadata.pqsResponse && metadata.pqsResponse?.message) {
      _satellite.track("form-error", { errorMsg: `Error submitting claim: ${metadata.pqsResponse?.message}` });
    }
  })
}

export const saveDocuments = () => (dispatch, getState) => {
  const { formData, step, metadata, saveState } = getState();
  const claimNumber = metadata.pqsResponse?.claim_number

  if (!claimNumber) return

  const data = {
    warranty_claims: {
      documents: [
        {
          name: "Proof of Purchase",
          urls: formData.proofOfRoofPurchase
        },
        {
          name: "Proof of Ownership",
          urls: formData.proofOfOwnerShip
        }
      ].filter(item => item.urls)
    }
  }

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/contractor/sphinx/warranty_claim_documents/${claimNumber}/upload`),
  {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(jsonData => {
    metadata.documents = jsonData;
  })
  .catch(err => {
    console.log(err);
    _satellite.track("form-error", { errorMsg: err });
  }).finally(() => {
    dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    dispatch(setMetadata({documents: metadata.documents}))
    if (metadata.documents?.message) {
      const pop = parseInt(formData.proofOfRoofPurchase?.length) || 0
      const pos = parseInt(formData.proofOfOwnerShip?.length) || 0
      dispatch(setAppData({ documentsCount: pop + pos}))
      incrementStep()(dispatch, getState);
    } else {
      console.log('Error uploading documents')
      _satellite.track("form-error", { errorMsg: 'Error uploading documents' });
    }
  })
}

export const savePhotos = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  const claimNumber = metadata.pqsResponse?.claim_number
  const { groundLevelFrontHome, groundLevelBackHome, affectedAreaWideAngle, affectedAreaCloseUp,
    ventIntakePhoto, ventExhaustPhoto, shingleFront, shingleBack, releaseTape, fasteners } = formData

  const photosCount = [groundLevelFrontHome, groundLevelBackHome, affectedAreaWideAngle, affectedAreaCloseUp,
    ventIntakePhoto, ventExhaustPhoto, shingleFront, shingleBack, releaseTape, fasteners]
    .reduce((sum, property) => sum + (property?.length ?? 0), 0)

  if (!claimNumber) return

  const data = {
    warranty_claims: {
      photos: [
        {name: "Front of Home", urls: groundLevelFrontHome},
        {name: "Back of Home", urls: groundLevelBackHome},

        {name: "Wide Angle", urls: affectedAreaWideAngle},
        {name: "Close Up", urls: affectedAreaCloseUp},

        {name: "Intake Photos", urls: ventIntakePhoto},
        {name: "Exhaust Photos", urls: ventExhaustPhoto},

        {name: "Front of Shingle", urls: shingleFront},
        {name: "Back of Shingle", urls: shingleBack},

        {name: "Release Tape", urls: releaseTape},
        {name: "Fasteners", urls: fasteners},
      ].filter(item => item.urls)
    }
  }

  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/contractor/sphinx/warranty_claim_photos/${claimNumber}/upload`),
  {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(jsonData => {
    metadata.photos = jsonData;
  })
  .catch(err => {
    console.log(err);
    _satellite.track("form-error", { errorMsg: err });
  }).finally(() => {
    dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    dispatch(setFormData({photos: metadata.photos}))
    if (metadata.photos?.message) {
      dispatch(setAppData({ photosCount }))
      incrementStep()(dispatch, getState);
    } else {
      console.log('Error uploading photos')
      _satellite.track("form-error", { errorMsg: 'Error uploading photos' });
    }
  })
}

const isAnyDocumentUploaded = (getState) =>  {
  const {formData} = getState();

  const {
    proofOfRoofPurchase,
    proofOfOwnerShip,
    groundLevelFrontHome,
    groundLevelBackHome,
    affectedAreaWideAngle,
    affectedAreaCloseUp,
    ventIntakePhoto,
    ventExhaustPhoto,
  } = formData

  const fields = [
    proofOfRoofPurchase,
    proofOfOwnerShip,
    groundLevelFrontHome,
    groundLevelBackHome,
    affectedAreaWideAngle,
    affectedAreaCloseUp,
    ventIntakePhoto,
    ventExhaustPhoto,
  ];
  return fields.some(field => field !== null);
}

export const notifyDocumentsUpload = () => (dispatch, getState) => {
  const { appData, metadata } = getState();

  // We want to only notify OCQS when a document/photo has been uploaded
  if(!isAnyDocumentUploaded(getState)) {
    dispatch(setStep(10))
    return;
  }

  dispatch({ type: "DISABLE_SUBMIT_BTN", disableSubmitBtn: true });
  dispatch({ type: 'SET_IS_FETCHING', isFetching: true })

  fetch((`${MDMS_URL}/api/v1/warranty_claims/notify-documents-upload`),
  {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(metadata?.pqsResponse)
  })
  .then(response => response.json())
  .then(jsonData => {
    appData.notifyRes = jsonData
  })
  .catch(err => {
    console.log(err);
  }).finally(() => {
    dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    dispatch(setAppData({notifyRes: appData.notifyRes}))
    dispatch({
      type: "DISABLE_SUBMIT_BTN",
      disableSubmitBtn: false,
    });
    dispatch(setStep(10))
  })
}

export const verifyAddress = (fieldKey) => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  let property = formData[fieldKey]

  dispatch({
    type: "SET_IS_FETCHING",
    isFetching: true,
  });

  fetch((MDMS_URL + `/api/v1/smarty/verification`),
  {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(
      {
        street_1: property.street,
        street_2: property.streetLine2,
        city: property.city,
        state_province: property.state,
        country_code: property.country,
        postal_code: property.zip,
      }
    )
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        return Promise.reject(response);
      }
    })
    .then(jsonData => {
      metadata.suggestedProperty = {
        street: jsonData.street_1,
        streetLine2: jsonData.street_2,
        city: jsonData.city,
        state: jsonData.state_province,
        zip: jsonData.postal_code
      }
    })
    .catch(err => {
      dispatch({
        type: "SET_IS_FETCHING",
        isFetching: false,
      });
      metadata.suggestedProperty = []
      metadata.suggestedOwner = []
      console.log(err);
    }).finally(() => {
      dispatch(setMetadata({suggestedProperty: metadata.suggestedProperty}))
      dispatch({ type: "SHOW_MODAL", showModal: true });
      dispatch({ type: 'SET_IS_FETCHING', isFetching: false })
    })
}
